import React from 'react'

const PromoVideo = () => {
  return (
    <div className="w-full flex flex-col items-center gap-10 mt-24">
      <h1>Elite Level Training</h1>
      <iframe
        className="w-[360px] h-[345px] sm:w-[480px] sm:h-[270px] md:w-[720px] md:h-[405px]  lg:w-[960px] lg:h-[540px]"
        title="vimeo-player" 
        src="https://player.vimeo.com/video/880857842?h=6c4c5680d0" 
        
        allowFullScreen>

      </iframe>
    </div>
  )
}

export default PromoVideo